<div class="col-xs-12 col-md-2 col-lg-1 menu-items-strip">
  <div class="col-xs-1 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-dashboard{{dashboardClass}}" [routerLink]="dashboardLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Dashboard</div>
  </div>
  <div class="col-xs-1 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-investment{{investmentClass}}" [routerLink]="investmentLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Investments</div>
  </div>
  <div class="col-xs-1 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-passbook{{passbookClass}}" [routerLink]="passbookLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Passbook</div>
  </div>
  <div *ngIf="this.isFinx == false" class="col-xs-1 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-preferences{{preferencesClass}}" [routerLink]="preferencesLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Preferences</div>
  </div>
  <div class="col-xs-1 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-wallet{{walletClass}}" [routerLink]="walletLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Wallet</div>
  </div>
  <div class="col-xs-1 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-consent{{consentClass}}" [routerLink]="consentLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Loan Agreements</div>
  </div>
  <div class="col-xs-1 col-md-12 menu-item-wrapper">
    <div class="menu-item finzy-provisional{{provisionalClass}}" [routerLink]="provisionalLink"></div>
    <div class="menu-item-label visible-md-block visible-lg-block">Interest Certificate</div>
  </div>
</div>
